<ng-select [items]="items$ | async"
           [placeholder]="placeholder"
           [typeahead]="input$"
           [formControl]="control"
           [loading]="isLoading">
</ng-select>
<app-error *ngIf="control.touched && control.invalid">
  {{requiredMessage}}
</app-error>
